import { TechSpaceErrorType } from "./index98.js";
import { getSortedModules } from "./index100.js";
import { errorHandler } from "./index101.js";
import { createGenericSpaceInstance } from "./index102.js";
import { createModularTechSpace } from "./index105.js";
import { tryInsertSpace } from "./index108.js";
import { RG_TYPE } from "@project-rouge/rg-core";
function positionModularSpaces(spaces, sortedApartments, dataset, sectionIndex, apartmentIndex, levelId, moduleIndex = 0) {
	const sortedApartmentsAndTechSpaces = [];
	const spacesAdded = [];
	const invalid = [];
	const generic = createGenericSpaceInstance();
	const spacesToAdd = spaces.slice();
	for (let i = 0; i < sectionIndex; i++) sortedApartmentsAndTechSpaces.push(sortedApartments[i]);
	while (sectionIndex < sortedApartments.length && spacesToAdd.length > 0) {
		sortedApartmentsAndTechSpaces.push([]);
		for (let j = 0; j < apartmentIndex; j++) sortedApartmentsAndTechSpaces[sectionIndex].push(sortedApartments[sectionIndex][j]);
		if (moduleIndex !== 0) {
			const modules = getSortedModules(sortedApartments[sectionIndex], apartmentIndex);
			for (let k = 0; k < moduleIndex; k++) {
				const techSpace = createModularTechSpace({
					space: generic,
					dataset,
					levelId
				}, [{
					module: modules[k],
					apartment: sortedApartments[sectionIndex][apartmentIndex]
				}]);
				sortedApartmentsAndTechSpaces[sectionIndex].push(techSpace);
				spacesAdded.push({
					name: generic.name,
					space: generic,
					size: {
						area: techSpace.size[0] * techSpace.size[2],
						sizeX: techSpace.size[0],
						sizeY: techSpace.size[1],
						sizeZ: techSpace.size[2]
					},
					consolidated: false,
					level: techSpace.data.level
				});
			}
		}
		for (const space of spacesToAdd.slice()) {
			const result = tryInsertSpace(space, apartmentIndex, moduleIndex, sortedApartments[sectionIndex]);
			if (!result.success && result.outOfBounds === "PosJ") break;
			else if (!result.success) invalid.push({
				name: space.space.name,
				space: space.space,
				includes: space.includes,
				error: errorHandler(TechSpaceErrorType.Size, {
					errorDimension: result.outOfBounds,
					spaceRequired: {
						area: space.area,
						sizeX: space.sizeX,
						sizeY: space.sizeY,
						sizeZ: space.sizeZ
					},
					invalidatedSize: space.invalidatedSize
				})
			});
			else {
				const modules = [];
				for (let j = apartmentIndex; j < result.newPos.apartmentIndex + 1; j++) {
					const start = j === apartmentIndex ? moduleIndex : 0;
					const limit = j === result.newPos.apartmentIndex ? result.newPos.moduleIndex : sortedApartments[sectionIndex][j].children.filter((ch) => ch.type === RG_TYPE.Module).length;
					if (limit !== 0) {
						const currentModules = getSortedModules(sortedApartments[sectionIndex], j);
						for (let k = start; k < limit; k++) modules.push({
							apartment: sortedApartments[sectionIndex][j],
							module: currentModules[k]
						});
					}
				}
				const techSpace = createModularTechSpace({
					space: space.space,
					includes: space.includes,
					dataset,
					levelId
				}, modules);
				sortedApartmentsAndTechSpaces[sectionIndex].push(techSpace);
				spacesAdded.push({
					name: space.space.name,
					space: space.space,
					includes: space.includes,
					size: {
						area: techSpace.size[0] * techSpace.size[2],
						sizeX: techSpace.size[0],
						sizeY: techSpace.size[1],
						sizeZ: techSpace.size[2]
					},
					spaceRequired: {
						area: space.area,
						sizeX: space.sizeX,
						sizeY: space.sizeY,
						sizeZ: space.sizeZ
					},
					consolidated: space.includes && space.includes.length > 0,
					invalidatedSize: space.invalidatedSize,
					level: sortedApartmentsAndTechSpaces[sectionIndex][sortedApartmentsAndTechSpaces[sectionIndex].length - 1].data.level
				});
				apartmentIndex = result.newPos.apartmentIndex;
				moduleIndex = result.newPos.moduleIndex;
			}
			spacesToAdd.shift();
		}
		if (moduleIndex !== 0) {
			const modules = getSortedModules(sortedApartments[sectionIndex], apartmentIndex);
			for (let k = moduleIndex; k < modules.length; k++) {
				const techSpace = createModularTechSpace({
					space: generic,
					dataset,
					levelId
				}, [{
					module: modules[k],
					apartment: sortedApartments[sectionIndex][apartmentIndex]
				}]);
				sortedApartmentsAndTechSpaces[sectionIndex].push(techSpace);
				spacesAdded.push({
					name: generic.name,
					space: generic,
					size: {
						area: techSpace.size[0] * techSpace.size[2],
						sizeX: techSpace.size[0],
						sizeY: techSpace.size[1],
						sizeZ: techSpace.size[2]
					},
					consolidated: false,
					level: techSpace.data.level
				});
			}
		}
		for (let j = moduleIndex === 0 ? apartmentIndex : apartmentIndex + 1; j < sortedApartments[sectionIndex].length; j++) sortedApartmentsAndTechSpaces[sectionIndex].push(sortedApartments[sectionIndex][j]);
		sectionIndex++;
		apartmentIndex = 0;
		moduleIndex = 0;
	}
	for (let i = sectionIndex; i < sortedApartments.length; i++) sortedApartmentsAndTechSpaces.push(sortedApartments[i]);
	for (const space of spacesToAdd) invalid.push({
		name: space.space.name,
		space: space.space,
		includes: space.includes,
		error: errorHandler(TechSpaceErrorType.NoSpaceLeft, {
			spaceRequired: {
				area: space.area,
				sizeX: space.sizeX,
				sizeY: space.sizeY,
				sizeZ: space.sizeZ
			},
			invalidatedSize: space.invalidatedSize
		})
	});
	return {
		sortedApartmentsAndTechSpaces,
		spacesAdded,
		invalidSpaces: invalid
	};
}
export { positionModularSpaces };

//# sourceMappingURL=index109.js.map